import { createAsyncThunk } from "@reduxjs/toolkit"

import { API } from "redux/api"

export const fetchTawk = createAsyncThunk("client/tawk/fetch", async () => {
  const response = await API.get("/client/tawk")
  return response.data
})
